import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-cell-favorite',
    templateUrl: './cell-favorite.component.html',
    styleUrls: ['./cell-favorite.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class CellFavoriteComponent {
    @Input()
    favorite: boolean;

    @Input()
    isHeader: boolean;

    @Output()
    favoriteChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    starIcon: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.starIcon = this.iconSanitizer.getIcon('star');
        this.favorite = false;
        this.isHeader = false;
    }

    toggleFav(event: Event) {
        if (this.isHeader) return;
        event.preventDefault();
        event.stopPropagation();
        this.favoriteChange.emit(!this.favorite);
    }

    onKeyDownToggleFav(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.toggleFav(event);
        }
    }
}
